var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Edit Service","size":"lg"},on:{"on-hide":_vm.resetFormData}},[_c('services-form',_vm._b({key:_vm.formKey,on:{"on-submit":_vm.updateService,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'services-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }